/**
 * Retrieves the value of the specified property key from an object if it exists and is a string.
 * Otherwise, returns the provided fallback string.
 *
 * @template T - The type of the input object.
 * @param {T} obj - The object to extract the property from.
 * @param {string} key - The property key to look for.
 * @param {string} fallback - The fallback string to return if the property is missing or not a string.
 *
 * @returns {string} The string value of the property, or the fallback string.
 */
export const getStringPropertyOrFallback = <T extends object>(
    obj: T,
    key: string,
    fallback: string,
): string => {
    if (
        typeof obj === "object" &&
        obj !== null &&
        key in obj &&
        typeof (obj as any)[key] === "string"
    ) {
        return (obj as any)[key]
    }
    return fallback
}
